<template>
  <main-content>
    <!-- Tab Navigation -->
      <div class="d-flex justify-content-between">
          <ul class="nav nav-pills" role="tablist">
              <li class="nav-item" @click="changeBoard(1)">
                  <router-link
                      class="nav-link"
                      :class="{ active: tab === 'pf-accounts-list' }"
                      to="/pf/accounting"
                      exact
                      role="tab"
                      aria-selected="false"
                  >
                      {{ "لیست حساب ها" }}
                  </router-link>
              </li>
              <li class="nav-item" @click="changeBoard(0)">
                  <router-link

                      class="nav-link"
                      :class="{ active: tab === 'pf-accounts-transactions-list' }"
                      to="/pf/accounting/transactions"
                      exact
                      role="tab"
                      aria-selected="false"
                  >
                      {{ $t("accounting.label.system_transactions") }}
                  </router-link>
              </li>

              <li class="nav-item">
                  <router-link
                      class="nav-link"

                      to="/pf/accounting/account/discrepancies"
                      exact
                      role="tab"
                      aria-selected="false"
                  >
                      {{ $t("accounting.label.accounting_discrepancies") }}
                  </router-link>
              </li>

              <li class="nav-item" @click="changeBoard(2)">
                  <router-link
                      class="nav-link"
                      :class="{ active: tab === 'pf-holidays-list' }"
                      to="/pf/accounting/holidays"
                      exact
                      role="tab"
                      aria-selected="false"
                  >
                      {{ "لیست روز های تعطیل" }}
                  </router-link>
              </li>
          </ul>
          <div class="nav-item" v-if="tab === 'pf-accounts-list' && $can('create-bank-account', 'accounting')">
              <button
                  class="btn btn-primary"
                  data-toggle="modal"
                  data-target="#description_modal"
              >
                  {{ $t("accounting.label.create_account") }}
              </button>
          </div>

          <div class="nav-item" v-if="tab === 'pf-accounts-transactions-list'">
              <button
                  class="btn btn-primary"
                  data-toggle="modal"
                  data-target="#transaction_modal"
              >
                  {{ $t("accounting.label.create_transaction") }}
              </button>
          </div>

          <div class="nav-item" v-if="tab === 'pf-holidays-list'">
              <button
                  class="btn btn-primary"
                  data-toggle="modal"
                  data-target="#create_holiday_modal"
              >
                  {{ $t("accounting.label.create_holiday") }}
              </button>
          </div>
      </div>

    <!-- Tab Content -->
    <div class="tab-content">

      <div v-if="tab === 'pf-accounts-list'" class="tab-pane active">
        <kt-datatable
          v-if="$can('read', 'accounting')"
          v-bind="datatableProps"
          ref="accountsDatatable"
        >
        </kt-datatable>
      </div>

      <!-- Transactions List Content -->
      <div v-if="tab === 'pf-accounts-transactions-list'" class="tab-pane active">
        <div>
          <div>
            <accounting-filter 
              :action="filterAction" 
              :query="query_filter" 
              :type="'pf'"
            />
          </div>
        </div>
        <kt-datatable
          v-if="$can('read', 'accounting')"
          v-bind="datatableTransactions"
          ref="transactionsDatatable"
        >
        </kt-datatable>
      </div>

      <!-- Holidays List Content -->
      <div v-if="tab === 'pf-holidays-list'" class="tab-pane active">
        <div>
          <holiday-filter v-if="$can('change-setting', 'accounting')" @holiday-filtered="handleHolidayFilter"/>
        </div>
        <kt-datatable
          v-if="$can('read', 'accounting')"
          v-bind="datatableHolidays"
          ref="holidaysDatatable"
        >
        </kt-datatable>
        <edit-holiday-modal v-if="$can('change-setting', 'accounting')" @holiday-updated="handleHolidayUpdated"/>
      </div>
      
    </div>
    <div
      v-if="$can('create-bank-account', 'accounting')"
      id="description_modal"
      class="modal fade rtl"
      role="dialog"
    >

    <!-- Modal for Creating Account -->
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div id="data_sheet" class="modal-body mb-4">
            <div class="modal-header">
              <h4 class="modal-title">{{ $t("accounting.label.create_account") }}</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="m-4">
              <form @submit.prevent="createNewAccount" method="post">
                <kt-form-section>
                  <!-- First Row: Company Type and Bank ID -->
                  <kt-form-row>
                    <kt-col xs="12" sm="6" md="6">
                      <kt-form-group>
                        <kt-form-label for="company_type">
                          {{ $t("accounting.label.please_select_company_type") }}
                          <select
                              size="1"
                              id="company_type"
                              class="form-control"
                              name="company_type"
                              v-model="company_type"
                          >
                            <option
                                v-for="(company_type, index) in companyTypes"
                                :key="index"
                                :value="company_type"
                            >
                              {{ companyTypesStr.get(company_type) }}
                            </option>
                          </select>
                        </kt-form-label>
                      </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="6">
                      <kt-form-group>
                        <kt-form-label for="bank_id">
                          {{ $t("accounting.label.please_select_bank") }}
                          <select
                              size="1"
                              id="bank_id"
                              class="form-control"
                              name="bank_id"
                              v-model="bank_id"
                          >
                            <option
                                v-for="(bank, index) in bankCodes"
                                :key="index"
                                :value="bank"
                            >
                              {{ bankIdStr.get(bank) }}
                            </option>
                          </select>
                        </kt-form-label>
                      </kt-form-group>
                    </kt-col>
                  </kt-form-row>
    
                  <!-- Second Row: Account Number Field -->
                  <kt-form-row>
                    <kt-col xs="12" sm="12" md="6">
                      <kt-form-group>
                        <kt-form-label for="account_number">
                          {{ $t("accounting.account_number") }}
                          <input
                              size="50"
                              type="text"
                              id="account_number"
                              class="form-control"
                              name="account_number"
                              v-model="account_number"
                              required
                          />
                          <div v-if="formErrors.account_number" class="text-danger">
                            {{ formErrors.account_number.join(', ') }}
                          </div>
                        </kt-form-label>
                      </kt-form-group>
                    </kt-col>

                    <kt-col xs="12" sm="12" md="6">
                      <kt-form-group>
                        <kt-form-label for="iban_number">
                          {{ $t("accounting.iban_number") }}
                          <div class="input-group">
                            <input
                                size="50"
                                type="text"
                                id="iban_number"
                                class="form-control"
                                name="iban_number"
                                v-model="iban_number"
                                required
                            />
                          </div>
                          <!-- Error message for IBAN Number -->
                          <div v-if="formErrors.sheba_number" class="text-danger">
                            {{ formErrors.sheba_number.join(', ') }}
                          </div>
                        </kt-form-label>
                      </kt-form-group>
                    </kt-col>
                  </kt-form-row>
    
                </kt-form-section>
    
                <kt-row>
                  <kt-col xs="12" sm="6" md="6">
                    <button
                        class="btn btn-success btn-wide float-left"
                        size="md"
                        type="submit"
                        id="reg_btn"
                    >
                      {{ $t("accounting.create_account") }}
                    </button>
                  </kt-col>
                </kt-row>
              </form>
            </div>
            </div>
          </div>
          </div>
        </div>

    <!-- Modal for Creating Holiday -->
    <div id="create_holiday_modal" class="modal fade rtl" role="dialog" tabindex="-1" aria-labelledby="transactionModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div id="data_sheet" class="modal-body mb-4">
            <div class="modal-header">
              <h4 class="modal-title">{{ $t("accounting.label.create_holiday") }}</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="m-4">
              <form @submit.prevent="createNewHoliday" method="post">
                <kt-form-section>
                  <!-- Second Row: Account Number Field -->
                  <kt-form-row>
                    <kt-col xs="12">
                      <kt-form-group>
                        <kt-form-label for="holiday_date">
                          {{ $t('accounting.label.holiday_date') }}
                        </kt-form-label>
                        <button id="reset_holiday_date"
                                @click="clearDate"
                                type="button"
                                class="btn btn-label-danger trash-btn"
                        >
                          <i class="la la-trash-o"></i>
                        </button>
                        <datePicker
                            format="YYYY-MM-DD"
                            display-format="jDD jMMMM jYYYY"
                            input-class="form-control"
                            id="holiday_date"
                            name="holiday_date"
                            v-model="holiday_date"
                            type="date" />
  
                        <div v-if="formErrors.holiday_date" class="text-danger">
                          {{ formErrors.holiday_date.join(', ') }}
                        </div>
                      </kt-form-group>
                    </kt-col>
                  </kt-form-row>
                </kt-form-section>
    
                <kt-row>
                  <kt-col xs="12" sm="6" md="6">
                    <button
                        class="btn btn-success btn-wide float-left"
                        size="md"
                        type="submit"
                        id="create_holiday_btn"
                    >
                      {{ $t("accounting.create_holiday") }}
                    </button>
                  </kt-col>
                </kt-row>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

<!-- Modal for Creating Transaction -->
<div v-if="$can('create-transaction', 'accounting')" id="transaction_modal" class="modal fade rtl" role="dialog">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">
          <div id="data_sheet" class="modal-body mb-4">
              <div class="modal-header">
                  <h4 class="modal-title" id="transactionModalLabel">{{ $t("accounting.label.create_transaction") }}</h4>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      &times;
                  </button>
              </div>
              <div class="m-4">
                <form @submit.prevent="createNewTransaction" method="post">
                  <!-- Row: Transaction Type and Recorded At -->
                  <kt-form-row>
                    <!-- Transaction Type Field -->
                    <kt-col xs="12" sm="6" md="6">
                      <kt-form-group>
                        <kt-form-label for="transaction_type">
                          {{ $t("accounting.label.please_select_transaction_type") }}
                        </kt-form-label>
                        <select
                          class="form-control"
                          name="transaction_type"
                          id="transaction_type"
                          v-model="tr_type_code"
                          required
                        >
                          <option v-for="(type, key) in TRANSACTION_TYPES" :key="key" :value="key">
                            {{ TRANSACTION_TYPES_STR.get(type) }}
                          </option>
                        </select>
                      </kt-form-group>
                    </kt-col>
                
                    <!-- Recorded At Field -->
                    <kt-col xs="12" sm="6" md="6">
                      <kt-form-group>
                        <kt-form-label for="recorded_at">
                          {{ $t('accounting.label.recorded_at') }}
                        </kt-form-label>
                        <div class="d-flex align-items-center">
                          <datePicker
                            format="YYYY-MM-DD HH:mm:ss"
                            display-format="dddd jDD jMMMM jYYYY HH:mm"
                            input-class="form-control"
                            id="recorded_at"
                            name="recorded_at"
                            v-model="recorded_at"
                            style="width: 100%;"
                            type="datetime"
                          />
                        </div>
                        <div v-if="formErrors.recorded_at" class="text-danger">
                          {{ formErrors.recorded_at.join(', ') }}
                        </div>
                      </kt-form-group>
                    </kt-col>
                  </kt-form-row>
                
                  <!-- Row: Account Select and Amount -->
                  <kt-form-row>
                    <!-- Account Select Field -->
                    <kt-col xs="12" sm="6" md="6">
                      <kt-form-group>
                        <kt-form-label for="account_select">
                          {{ $t("accounting.label.select_account") }}
                        </kt-form-label>
                        <select
                          class="form-control"
                          name="account_select"
                          id="account_select"
                          v-model="selectedAccount"
                          required
                        >
                          <option v-for="account in accounts" :key="account.id" :value="account.id">
                            {{ account.account_number }} - {{ account.bank_name }} - {{ account.company }}
                          </option>
                        </select>
                      </kt-form-group>
                    </kt-col>
                
                    <!-- Amount Field -->
                    <kt-col xs="12" sm="6" md="6">
                      <kt-form-group>
                        <kt-form-label for="amount">
                          {{ $t("accounting.amount") }}
                        </kt-form-label>
                        <input
                          type="number"
                          id="amount"
                          class="form-control"
                          name="amount"
                          v-model="amount"
                          required
                        />
                      </kt-form-group>
                    </kt-col>
                  </kt-form-row>
                
                  <!-- Row: Description -->
                  <kt-form-row>
                    <!-- Description Field -->
                    <kt-col xs="12" sm="6" md="6">
                      <kt-form-group>
                        <kt-form-label for="description">
                          {{ $t("accounting.description") }}
                        </kt-form-label>
                        <textarea
                          id="description"
                          class="form-control"
                          name="description"
                          v-model="description"
                          rows="4"
                        ></textarea>
                      </kt-form-group>
                    </kt-col>
                  </kt-form-row>
                
                  <!-- Submit Button -->
                  <kt-form-row>
                    <kt-col xs="12" sm="6" md="6">
                      <button
                        class="btn btn-success btn-wide float-left"
                        size="md"
                        type="submit"
                        id="transaction_btn"
                      >
                        {{ $t("accounting.label.create_transaction") }}
                      </button>
                    </kt-col>
                  </kt-form-row>
                </form>
                
              </div>
          </div>
      </div>
  </div>
</div>
  </main-content>
</template>


<script>
import $ from "jquery";
import MainContent from "@/components/main-content.vue";
import { ApiUrl } from "@/common/api.service";
import { AuthorizationHeader } from "@/common/jwt.service";
import toastr from "toastr";
import commonAccessColumns from "./datatable/commonAccessColumns";
import { KTApp } from "@/plugins/core/app";
import { accountingService } from "@/common/api.service";
import { companyTypes, companyTypesStr } from "@/constants/accountingType";
import { bankIdStr, bankCodes } from "@/constants/accountingIban";
import { actionColumn } from "./components";
import {
  TRANSACTION_TYPES,
  TRANSACTION_TYPES_STR,
} from "@/constants/accountingTransactionType";
import transactionColumn from "@/views/accounting/datatable/transactionColumn";
import transactionActionColumn from "@/views/accounting/components/transaction-action-column.vue";
import HolidayActionColumn from "@/views/accounting/components/holiday-action-column.vue";
import EditHolidayModal from "@/views/accounting/components/holiday-edit-modal.vue";
import Button from "@/components/elements/button.vue";
import AccountingFilter from "@/views/accounting/components/accounting-filter.vue";
import holidayColumns from "./datatable/holidayColumns";
import holidayFilter from "./components/holiday-filter.vue";
import AmountInput from "@/components/custom-elements/amount-input";

export default {
  name: "AccountingComponent",
  components: { holidayFilter, HolidayActionColumn, EditHolidayModal, Button, MainContent, actionColumn, transactionActionColumn, AccountingFilter, AmountInput },
  data() {
    return {
      tab: this.setTab(),
      selectedAccountId: "",
      bank_id: "",
      showCreateAccountModal: false,
      showTransactionModal: false,
      showCreateHolidayModal: false,
      companyType: "",
      company_type: "",
      account_number: "",
      iban_number: "",
      description: "",
      amount: null,
      tr_type_code: null,
      companyTypes,
      companyTypesStr,
      bankIdStr,
      bankCodes,
      holiday_date: "",
      holiday_query_filters: {},
      TRANSACTION_TYPES,
      TRANSACTION_TYPES_STR,
      formErrors: {},
      accounts: [],
      selectedAccount: '',
      recorded_at: '',
      query_filter: {

      }

    };
  },
  watch: {
    tab(newValue) {
      if (newValue === 'pf-accounts-list') {
        this.$refs.accountsDatatable.reload();
      } else if (newValue === 'pf-accounts-transactions-list') {
        this.$refs.transactionsDatatable.reload();
      }
    },
    '$route.path': function(newPath) {
      this.tab = this.setTab;
    },
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false,
      };
      return toastr;
    },
    datatableTransactions() {
      return {
        id: "accounting_detail_transaction",
        data: {
          type: "remote",
          source: {
            read: {
              url: ApiUrl.path("accounting/admin/transactions"),
              method: "GET",
              headers: AuthorizationHeader,
              map: (res) => res.data.data,
              params: {
                query: this.query_filter
              },
            },
          },
          pageSize: 15,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        pagination: false,
        sortable: false,
        columns: [...transactionColumn],
        actions: transactionActionColumn,
      };
    },
    datatableHolidays() {
      return {
        id: "accounting_holidays",
        data: {
          type: "remote",
          source: {
            read: {
              url: ApiUrl.path("accounting/admin/holidays"),
              method: "GET",
              headers: AuthorizationHeader,
              map: (res) => res.data.data,
              params: {
                query: this.holiday_query_filters
              },
            },
          },
          pageSize: 15,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        pagination: false,
        sortable: false,
        columns: [...holidayColumns],
        actions: HolidayActionColumn,
      };
    },
    datatableProps() {
      return {
        id: "accounting_accounts_datatable",
        data: {
          type: "remote",
          source: {
            read: {
              url: ApiUrl.path("accounting/admin/accounts"),
              method: "GET",
              headers: AuthorizationHeader,
              map: (res) => {
                return res.data.data;
              },
              params: {
                query: this.query_filter,
              },
            },
          },
          pageSize: 15,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        layout: {},
        pagination: false,
        sortable: false,
        columns: [...commonAccessColumns],
        actions: actionColumn,
      };
    },

  },
  created() {
    this.account_hashid = this.$route.params.hashid;
    this.fetchAccounts()
  },
  methods: {
    setTab() {    
        if (this.$route.path === "/pf/accounting") {
          return 'pf-accounts-list';
        }
        else if (this.$route.path === "/pf/accounting/holidays") {
          return 'pf-holidays-list';
        }
        return 'pf-accounts-transactions-list';
    },
    getTransactionTypeId(transaction_type) {
      return TRANSACTION_TYPES[transaction_type] || null;
    },
    openCreateTransactionModal() {
      this.showTransactionModal = true;
    },
    openCreateAccountModal() {
      this.showCreateAccountModal = true;
    },
    openCreateHolidayModal() {
      this.showTransactionModal = true;
    },
    closeCreateAccountModal() {
      this.showCreateAccountModal = false;
    },
    filterAction(e, query) {
      let form = $('#transaction-filter-form')
      this.query = query
      this.query_filter = query
      this.$refs.transactionsDatatable.reload()
    },
    handleFilterChange(query) {
      this.datatableTransactions.data.source.read.params = {
        ...this.datatableTransactions.data.source.read.params,
        ...query
      };
      this.$refs.transactionsDatatable.reload();
    },
    changeBoard(board) {
      switch (board) {
        case 0:
          this.tab = 'pf-accounts-transactions-list';
          break;
        case 1:
          this.tab = 'pf-accounts-list';
          break;
        case 2:
          this.tab = 'pf-holidays-list';
          break;
        default:
          this.tab = 'pf-accounts-list';
          break;
      }
      this.reloadDatatable();
    },
    reloadDatatable() {
      if (this.tab === 'pf-accounts-list' && this.$refs.accountsDatatable) {
        this.$refs.accountsDatatable.reload();
      } else if (this.tab === 'pf-accounts-transactions-list' && this.$refs.transactionsDatatable) {
        this.$refs.transactionsDatatable.reload();
      }
      else if (this.tab === 'pf-holidays-list') {
        this.$refs.transactionsDatatable.reload();
      }
    },
    showTransactionList() {
      this.tab = 'pf-accounting-transactions-list';
      if (this.tab === 'pf-accounts-transactions-list') {
        this.$refs.transactionsDatatable.reload();
      }
    },
    createNewAccount(e) {
      let form = $(e.target);

      if (!this.checkFormValidate(form)) {
        return;
      }

      let btn = $("#reg_btn");
      KTApp.progress(btn);

      accountingService
          .createAccount({
            company_id: this.company_type,
            account_number: this.account_number,
            sheba_number: this.iban_number,
            bank_id: this.bank_id,
          })
          .then(() => {
            KTApp.unprogress(btn);
            $("#description_modal").modal("hide");
            this.$refs.accountsDatatable.reload();
            this.clearFormData();
            this.formErrors = {}
          })
          .catch(({ response }) => {
            KTApp.unprogress(btn);

            if (response.data && response.data.data) {
              this.formErrors = {};
              Object.keys(response.data.data).forEach((field) => {
                this.formErrors[field] = response.data.data[field];
              });
            }
          })
          .finally(() => {
            KTApp.unprogress(btn);
          });
    },
    createNewTransaction(e) {
      let form = $(e.target);

      if (!this.checkFormValidate(form)) {
        return;
      }

      let btn = $("#transaction_btn");
      KTApp.progress(btn);

      accountingService
        .createAccountTransaction({
          hashid: this.selectedAccount,
          type: this.getTransactionTypeId(this.tr_type_code),
          amount: this.amount,
          description: this.description,
          recorded_at: this.recorded_at,
        })
        .then((response) => {
          KTApp.unprogress(btn);
          $("#transaction_modal").modal("hide");
          this.$refs.transactionsDatatable.reload();
          this.clearFormData();
        })
        .catch(({ response }) => {
          if (response.data) {
            form.validate().showErrors(response.data.message);
          }
          this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {
          KTApp.unprogress(btn);
        });
    },
    createNewHoliday(e) {
      let form = $(e.target);

      if (!this.checkFormValidate(form)) {
        return;
      }

      let btn = $("#create_holiday_btn");
      KTApp.progress(btn);

      accountingService
        .createHoliday({
          holiday_date: this.holiday_date
        })
        .then((response) => {
          KTApp.unprogress(btn);
          $("#create_holiday_modal").modal("hide");
          this.$refs.holidaysDatatable.reload();
          this.clearHolidayFormData();
        })
        .catch(({ response }) => {
          if (response.data) {
            console.log(response.data);
            
            if (response.data && response.data.data) {
              this.formErrors = {};
              Object.keys(response.data.data).forEach((field) => {
                this.formErrors[field] = response.data.data[field];
              });
            }
          }
          this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {
          KTApp.unprogress(btn);
        });
    },
    clearFormData() {
      this.company_type = "";
      this.account_number = "";
      this.iban_number = '';
      this.bank_id = "";
    },

    clearHolidayFormData() {
      this.holiday_date = "";
    },

    clearDate() {
      if (this.holiday_date) {
        this.holiday_date = null;
      }
    },

    checkFormValidate(form) {
      return true;
    },
    checkValidateIBAN(iban) {
      return !(!iban.startsWith("IR") ||
          iban.length !== 26 ||
          !/^\d{24}$/.test(iban.substring(2)));
    },
    fetchAccounts() {
      accountingService.getAllAccounts()
        .then(response => {
          this.accounts = response.data.data;
        })
    },
    handleHolidayUpdated() {
      this.$refs.holidaysDatatable.reload();
    },
    handleHolidayFilter(query) {
      this.holiday_query_filters = query;
      this.$refs.holidaysDatatable.reload();
    }
  },
};
</script>

<style scoped>

.same-size {
  width: 100%;  /* Ensure inputs fill the available width */
}

.kt-datatable.kt-datatable--default,
> .kt-datatable__table,
> .kt-datatable__body,
.kt-datatable__row,
> .kt-datatable__cell,
.kt-datatable.kt-datatable--default,
> .kt-datatable__table,
> .kt-datatable__head,
.kt-datatable__row,
> .kt-datatable__cell.kt-datatable__cell--sort {
  padding: 8px !important;
}
.kt-datatable.kt-datatable--default
> .kt-datatable__table
> .kt-datatable__body
.kt-datatable__row
> .kt-datatable__cell:first-child,
.kt-datatable.kt-datatable--default,
> .kt-datatable__table,
> .kt-datatable__head,
.kt-datatable__row,
> .kt-datatable__cell:first-child {
  padding-right: 20px !important;
}

</style>
